import ViewBase from "../../../../framework/core/mvvm/view_base";
import DailySignItem from "./dailysign_item";

const { ccclass, property } = cc._decorator;
@ccclass
export default class DailySignView extends ViewBase {
    @property([DailySignItem])
    itemList: DailySignItem[] = []

    @property(DailySignItem)
    itemAttach: DailySignItem = null

    @property(cc.Button)
    buttonSign: cc.Button = null

    showPanel(dataMap){
        let dailyDataMap = dataMap.dailyDataMap
        for (let index = 0; index < this.itemList.length; index++) {
            const item = this.itemList[index];
            const itemData = dailyDataMap.dailyDataList[index]
            item.show(true, itemData)            
        }
        let attachDataMap = dataMap.attachDataMap
        let attachItemData = attachDataMap.attachDataList[attachDataMap.currentConditionGroup - 1]
        this.itemAttach.show(true, attachItemData)

        let canSign = dailyDataMap.currentConditionGroup > 0 && dailyDataMap.isReceive && (!dailyDataMap.isFinish)
        this.buttonSign.interactable = !!canSign
    }

}